import bannerImage from "../assets/images/initiatives/waheader.webp";
import scrollimage1 from "../assets/images/products/app1.webp";
import scrollimage2 from "../assets/images/products/app2.webp";
import scrollimage3 from "../assets/images/products/app3.webp";

export const headerData = {
  image: bannerImage,
  heading: "Wikipedia Advocacy",
  desc: "An initiative to ensure fair representation of alternative scientific perspectives on Wikipedia through policy advocacy and community collaboration.",
};

export const tiltHeadData = {
  bgText: "Wiki Advocacy",
  title: "Wikipedia Advocacy Initiative",
  desc: "Wikipedia is one of the most influential sources of knowledge, yet it often dismisses entire fields as pseudoscience without fair evaluation. Our Wikipedia Advocacy Initiative works to correct this imbalance by mobilizing volunteers, advocating policy changes, and preparing credible edits so that valid scientific perspectives are represented.",
};

export const scrollCardsData = [
  {
    title: "Background",
    desc: "Wikipedia has a history of labeling whole areas of study as pseudoscience, regardless of research quality. Our initiative was created to advocate for balanced representation and open dialogue. Add your voice by clicking the button.",
    btn: "Join the Advocacy",
    img: scrollimage1,
    link: "https://docs.google.com/forms/d/e/1FAIpQLSf0WTmE0RXZb5XWzRMKSNIUGX2kjqpMSY3aNLsvwH_UZqQJ6A/viewform",
  },
  {
    title: "Purpose",
    desc: "Our purpose is to make Wikipedia a more accurate, less biased source by ensuring that alternative scientific research is represented fairly. This benefits the public, researchers, and the credibility of knowledge as a whole.",
    btn: "Join the Advocacy",
    img: scrollimage2,
    link: "https://docs.google.com/forms/d/e/1FAIpQLSf0WTmE0RXZb5XWzRMKSNIUGX2kjqpMSY3aNLsvwH_UZqQJ6A/viewform",
  },
  {
    title: "Approach",
    desc: "We mobilize volunteers to advocate for policy changes such as reforming the False Balance rule which is used as an excuse to exclude expert perspectives that don't denigrate parapsychology. We prepare scientific information, collaborate with Wikipedia editors, and persistently monitor pages to maintain accurate representation.",
    btn: "Join the Advocacy",
    img: scrollimage3,
    link: "https://docs.google.com/forms/d/e/1FAIpQLSf0WTmE0RXZb5XWzRMKSNIUGX2kjqpMSY3aNLsvwH_UZqQJ6A/viewform",
  },
];

export const wikipediaDetailsData = [
  {
    id: 1,
    title: "Policy Change",
    desc: "Advocating for updates to Wikipedia policies like the False Balance rule to allow fair representation of diverse scientific perspectives.",
    secHead: "DETAILS",
    secSubHead1: "WIKIPEDIA",
    secSubHead2: "ADVOCACY",
  },
  {
    id: 2,
    title: "Volunteer Network",
    desc: "Recruiting and coordinating volunteers to support edits, debates, and policy requests with credibility and persistence.",
    secHead: "DETAILS",
    secSubHead1: "WIKIPEDIA",
    secSubHead2: "ADVOCACY",
  },
  {
    id: 3,
    title: "Content Preparation",
    desc: "Creating well-documented summaries of scientific research that can be added to Wikipedia in compliance with its standards.",
    secHead: "DETAILS",
    secSubHead1: "WIKIPEDIA",
    secSubHead2: "ADVOCACY",
  },
  {
    id: 4,
    title: "Editor Collaboration",
    desc: "Engaging with existing Wikipedia editors to build consensus, gain support, and increase the chances of accepted changes.",
    secHead: "DETAILS",
    secSubHead1: "WIKIPEDIA",
    secSubHead2: "ADVOCACY",
  },
  {
    id: 5,
    title: "Monitoring & Debate",
    desc: "Tracking Wikipedia pages, restoring removed edits, and participating in discussions to defend balanced representation.",
    secHead: "DETAILS",
    secSubHead1: "WIKIPEDIA",
    secSubHead2: "ADVOCACY",
  },
  {
    id: 6,
    title: "Public Impact",
    desc: "As Wikipedia influences global knowledge, this initiative ensures millions of readers receive a fairer and more balanced view of science.",
    secHead: "DETAILS",
    secSubHead1: "WIKIPEDIA",
    secSubHead2: "ADVOCACY",
  },
];

